import { Component, OnInit, inject } from '@angular/core';
import { ModalRef, ModalModule, CheckboxV2Module, ButtonV2Module } from '@schenck/rotec-components';
import { MODAL_WIDTH } from 'src/utils/constants/modal.const';
import { RotorTypeSyncStates } from 'src/utils/enums/rotor-type.enum';
import {
  RotorTypeRequest,
  PaginatedRotorTypeData,
} from 'src/utils/interfaces/rotor-type.interfaces';
import { TranslateService, TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rm-delete-rotor-type-modal',
  templateUrl: './delete-rotor-type-modal.component.html',
  styleUrls: ['./delete-rotor-type-modal.component.less'],
  imports: [ModalModule, TranslatePipe, TranslateDirective, CheckboxV2Module, ButtonV2Module],
})
export class DeleteRotorTypeModalComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  public modalRef = inject<
    ModalRef<{
      rotorTypes: PaginatedRotorTypeData[];
    }>
  >(ModalRef);

  /**
   * The width of the modal.
   */
  public width: string = MODAL_WIDTH;
  /**
   * The checkbox for deleting rotor type on machine or not
   */
  public isDeleteOnMachine: boolean = false;
  /**
   * The rotor types which are synced to the machine
   */
  public syncedRotorTypes: PaginatedRotorTypeData[] = [];
  /**
   * The machines which rotor type is synced
   */
  public syncedMachines: string[] = [];
  /**
   * The title of the modal header
   */
  public title: string;
  /**
   * The title of the sync checkbox
   */
  public syncTitle: string;
  /**
   * The filtered rotor types which have rights for deletion
   */
  public rotorTypes: PaginatedRotorTypeData[];

  constructor() {
    const modalRef = this.modalRef;

    this.rotorTypes = modalRef.data.rotorTypes;
    this.title = this.getTitle(modalRef.data.rotorTypes);
  }

  public ngOnInit(): void {
    this.syncedRotorTypes = this.rotorTypes.filter(
      ({ syncState }) => syncState === RotorTypeSyncStates.Sync
    );

    if (this.syncedRotorTypes.length) {
      this.syncTitle = this.getTitle(this.syncedRotorTypes);
      this.syncedRotorTypes.forEach(({ machineName }) => {
        if (machineName && !this.syncedMachines.includes(machineName)) {
          this.syncedMachines = [...this.syncedMachines, machineName];
        }
      });
    }
  }

  public close(): void {
    this.modalRef.emitAndClose(null);
  }

  public apply(): void {
    this.modalRef.emitAndClose(this.mapToDeleteRequest());
  }

  public toggleCheckbox(): void {
    this.isDeleteOnMachine = !this.isDeleteOnMachine;
  }

  private getTitle(rotorTypes: PaginatedRotorTypeData[]): string {
    const length = rotorTypes.length;

    return length > 1
      ? `${length} ${this.translateService.instant('Rotor Types')}`
      : rotorTypes[0].name;
  }

  private mapToDeleteRequest(): RotorTypeRequest[] {
    return this.modalRef.data.rotorTypes.map(({ id, concurrencyToken, syncState, name }) => ({
      id,
      concurrencyToken,
      deleteOnMachine: syncState === RotorTypeSyncStates.Sync ? this.isDeleteOnMachine : false,
      name,
    }));
  }
}
